var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g2, _g3, _g4, _path20, _path21, _path22, _path23, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPadlockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 130,
    viewBox: "0 0 154 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.2233 117.341C107.437 117.341 133.57 91.078 133.57 58.6056C133.57 26.1332 107.437 0 75.2233 0C43.0096 0 16.8765 26.2625 16.8765 58.735C16.8765 91.2074 43.0096 117.341 75.2233 117.341Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.943 116.564C95.0166 116.823 84.408 116.564 76.7751 116.435C69.2715 116.694 58.5336 116.823 49.6069 116.564C58.4042 111.519 61.5092 102.204 61.8973 95.9941H91.3941C92.1704 102.075 95.2753 111.519 103.943 116.564Z",
    fill: "url(#paint0_linear_1348_27185)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1348_27185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.535 17.7239V94.9591C132.535 96.8997 130.983 98.3228 129.301 98.3228H24.8974C23.0862 98.3228 21.6631 96.7703 21.6631 94.9591V17.7239C21.6631 15.9127 23.2156 14.3602 24.8974 14.3602H129.171C131.112 14.3602 132.535 15.9127 132.535 17.7239Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.535 17.7239V84.2212H21.6631V17.7239C21.6631 15.9127 23.2156 14.3602 24.8974 14.3602H129.171C131.112 14.3602 132.535 15.9127 132.535 17.7239Z",
    fill: "#989FB0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.266 18.6296H25.415V80.4695H128.395V18.6296H128.266Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M43.3098 77.5635V81.3471H33.0842C31.9193 81.3471 31.0132 81.0683 31.0132 80.7098V78.2804C31.0132 77.9219 31.9193 77.6431 33.0842 77.6431L43.3098 77.5635Z",
    fill: "#989FB0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9053 93.7153C78.4578 93.7153 79.6221 92.5509 79.6221 90.9984C79.6221 89.446 78.4578 88.2816 76.9053 88.2816C75.3528 88.2816 74.1885 89.446 74.1885 90.9984C74.1885 92.5509 75.3528 93.7153 76.9053 93.7153Z",
    fill: "#D0D8E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M122.315 30.0144V37.9061C122.315 39.0704 121.41 39.976 120.245 39.976H33.3073C32.1429 39.976 31.2373 39.0704 31.2373 37.9061V30.0144C31.2373 28.85 32.1429 27.9444 33.3073 27.9444H120.116C121.41 27.8151 122.315 28.85 122.315 30.0144Z",
    fill: "#E5E9F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M122.315 46.5738V54.4655C122.315 55.6299 121.41 56.5355 120.245 56.5355H33.3073C32.1429 56.5355 31.2373 55.6299 31.2373 54.4655V46.5738C31.2373 45.4095 32.1429 44.5039 33.3073 44.5039H120.116C121.41 44.3745 122.315 45.4095 122.315 46.5738Z",
    fill: "#E5E9F1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M43.3983 27.8149V40.1053H33.1779C32.0135 40.1053 31.1079 39.1997 31.1079 38.0353V30.1436C31.1079 28.9793 32.0135 28.0737 33.1779 28.0737L43.3983 27.8149Z",
    fill: "#989FB0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M43.3035 44.4572V56.7475H33.0831C31.9188 56.7475 31.0132 55.8419 31.0132 54.6776V46.7859C31.0132 45.6215 31.9188 44.7159 33.0831 44.7159L43.3035 44.4572Z",
    fill: "#989FB0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M43.3098 60.5374V72.834H33.0842C31.9193 72.834 31.0132 71.9279 31.0132 70.763V62.8672C31.0132 61.7023 31.9193 60.7962 33.0842 60.7962L43.3098 60.5374Z",
    fill: "#989FB0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M122.315 63.1336V71.0253C122.315 72.1897 121.41 73.0953 120.245 73.0953H33.3073C32.1429 73.0953 31.2373 72.1897 31.2373 71.0253V63.1336C31.2373 61.9693 32.1429 61.0637 33.3073 61.0637H120.116C121.41 60.9343 122.315 61.8399 122.315 63.1336Z",
    fill: "#E5E9F1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M122.315 79.564V80.4696H31.1079V79.564C31.1079 78.3996 32.0135 77.494 33.1779 77.494H120.116C121.41 77.494 122.315 78.3996 122.315 79.564Z",
    fill: "#E5E9F1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6839 23.4165C30.3307 23.4165 30.8482 22.899 30.8482 22.2521C30.8482 21.6053 30.3307 21.0878 29.6839 21.0878C29.037 21.0878 28.5195 21.6053 28.5195 22.2521C28.5195 22.899 29.037 23.4165 29.6839 23.4165Z",
    fill: "#E3EAF2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4363 23.4165C34.0832 23.4165 34.6007 22.899 34.6007 22.2521C34.6007 21.6053 34.0832 21.0878 33.4363 21.0878C32.7895 21.0878 32.272 21.6053 32.272 22.2521C32.272 22.899 32.7895 23.4165 33.4363 23.4165Z",
    fill: "#E3EAF2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1883 23.4165C37.8351 23.4165 38.3526 22.899 38.3526 22.2521C38.3526 21.6053 37.8351 21.0878 37.1883 21.0878C36.5414 21.0878 36.0239 21.6053 36.0239 22.2521C36.0239 22.899 36.5414 23.4165 37.1883 23.4165Z",
    fill: "#E3EAF2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2017 116H136.202",
    stroke: "#FD784C",
    strokeWidth: 1.89179,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88696 50.7258C12.0288 50.7258 13.7651 48.9895 13.7651 46.8477C13.7651 44.7058 12.0288 42.9695 9.88696 42.9695C7.74511 42.9695 6.00879 44.7058 6.00879 46.8477C6.00879 48.9895 7.74511 50.7258 9.88696 50.7258Z",
    fill: "#EAEEF9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00887 38.1454C7.4716 38.1454 8.65737 36.9596 8.65737 35.4969C8.65737 34.0342 7.4716 32.8484 6.00887 32.8484C4.54613 32.8484 3.36035 34.0342 3.36035 35.4969C3.36035 36.9596 4.54613 38.1454 6.00887 38.1454Z",
    fill: "#EAEEF9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M116.702 7.10818C118.164 7.10818 119.35 5.9224 119.35 4.45967C119.35 2.99694 118.164 1.81116 116.702 1.81116C115.239 1.81116 114.053 2.99694 114.053 4.45967C114.053 5.9224 115.239 7.10818 116.702 7.10818Z",
    fill: "#EAEEF9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M144.721 60.4814C147.437 60.4814 149.64 58.2792 149.64 55.5627C149.64 52.8462 147.437 50.644 144.721 50.644C142.004 50.644 139.802 52.8462 139.802 55.5627C139.802 58.2792 142.004 60.4814 144.721 60.4814Z",
    fill: "#EAEEF9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1348_27185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0594 36.89C36.2336 36.89 36.3747 36.7488 36.3747 36.5747C36.3747 36.4006 36.2336 36.2594 36.0594 36.2594C35.8853 36.2594 35.7441 36.4006 35.7441 36.5747C35.7441 36.7488 35.8853 36.89 36.0594 36.89Z",
    stroke: "white",
    strokeWidth: 0.630598,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5814 36.89C38.7555 36.89 38.8967 36.7488 38.8967 36.5747C38.8967 36.4006 38.7555 36.2594 38.5814 36.2594C38.4073 36.2594 38.2661 36.4006 38.2661 36.5747C38.2661 36.7488 38.4073 36.89 38.5814 36.89Z",
    stroke: "white",
    strokeWidth: 0.630598,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5366 31.2146H34.6402C34.6402 31.2146 34.7704 31.7911 34.8538 32.1605C35.0205 32.8986 35.2494 33.9124 35.3838 34.5071C35.4487 34.7946 35.704 34.9982 35.9987 34.9982H38.7062C39.0017 34.9982 39.2576 34.7929 39.3217 34.5044L39.8426 32.1605",
    stroke: "white",
    strokeWidth: 0.630598,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8427 32.1605H34.9556",
    stroke: "white",
    strokeWidth: 0.630598,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1348_27185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0594 53.9161C36.2336 53.9161 36.3747 53.775 36.3747 53.6008C36.3747 53.4267 36.2336 53.2855 36.0594 53.2855C35.8853 53.2855 35.7441 53.4267 35.7441 53.6008C35.7441 53.775 35.8853 53.9161 36.0594 53.9161Z",
    stroke: "white",
    strokeWidth: 0.630598,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5814 53.9161C38.7555 53.9161 38.8967 53.775 38.8967 53.6008C38.8967 53.4267 38.7555 53.2855 38.5814 53.2855C38.4073 53.2855 38.2661 53.4267 38.2661 53.6008C38.2661 53.775 38.4073 53.9161 38.5814 53.9161Z",
    stroke: "white",
    strokeWidth: 0.630598,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5366 48.2407H34.6402C34.6402 48.2407 34.7704 48.8172 34.8538 49.1866C35.0205 49.9247 35.2494 50.9385 35.3838 51.5332C35.4487 51.8207 35.704 52.0243 35.9987 52.0243H38.7062C39.0017 52.0243 39.2576 51.819 39.3217 51.5305L39.8426 49.1866",
    stroke: "white",
    strokeWidth: 0.630598,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8427 49.1866H34.9556",
    stroke: "white",
    strokeWidth: 0.630598,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1348_27185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0594 69.0505C36.2336 69.0505 36.3747 68.9094 36.3747 68.7352C36.3747 68.5611 36.2336 68.4199 36.0594 68.4199C35.8853 68.4199 35.7441 68.5611 35.7441 68.7352C35.7441 68.9094 35.8853 69.0505 36.0594 69.0505Z",
    stroke: "white",
    strokeWidth: 0.630598,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5814 69.0505C38.7555 69.0505 38.8967 68.9094 38.8967 68.7352C38.8967 68.5611 38.7555 68.4199 38.5814 68.4199C38.4073 68.4199 38.2661 68.5611 38.2661 68.7352C38.2661 68.9094 38.4073 69.0505 38.5814 69.0505Z",
    stroke: "white",
    strokeWidth: 0.630598,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5366 63.3751H34.6402C34.6402 63.3751 34.7704 63.9516 34.8538 64.321C35.0205 65.0591 35.2494 66.0729 35.3838 66.6676C35.4487 66.9551 35.704 67.1587 35.9987 67.1587H38.7062C39.0017 67.1587 39.2576 66.9534 39.3217 66.6649L39.8426 64.321",
    stroke: "white",
    strokeWidth: 0.630598,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8427 64.321H34.9556",
    stroke: "white",
    strokeWidth: 0.630598,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M128.266 18.6296H25.415V80.4695H128.395V18.6296H128.266Z",
    fill: "black",
    fillOpacity: 0.55
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2652 66.9384H67.9356C66.0264 66.9384 64.4844 65.393 64.4844 63.4798V39.417C64.4844 32.7206 69.9182 27.3488 76.527 27.3488C83.1358 27.3488 88.5696 32.7942 88.5696 39.417V63.5534C88.6431 65.393 87.101 66.9384 85.2652 66.9384ZM71.3869 60.0948H81.814V39.417C81.814 36.5471 79.4642 34.1923 76.6004 34.1923C73.7366 34.1923 71.3869 36.5471 71.3869 39.417V60.0948Z",
    fill: "#FFDDD2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3883 73.4876H61.0334C58.9039 73.4876 57.1416 71.7215 57.1416 69.5875V48.7625C57.1416 46.6285 58.9039 44.8624 61.0334 44.8624H92.3883C94.5178 44.8624 96.2801 46.6285 96.2801 48.7625V69.5875C96.2801 71.7215 94.5178 73.4876 92.3883 73.4876Z",
    fill: "#E02020"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6395 55.9739C80.6395 57.5192 79.7583 58.8438 78.51 59.5061V63.7741C78.51 64.8043 77.7023 65.6138 76.6742 65.6138C75.6462 65.6138 74.8385 64.8043 74.8385 63.7741V59.5061C73.5902 58.8438 72.709 57.5192 72.709 55.9739C72.709 53.7663 74.4713 52.0002 76.6742 52.0002C78.8772 52.0002 80.6395 53.7663 80.6395 55.9739Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1348_27185",
    x: 0.853355,
    y: 3.95536,
    width: 152.492,
    height: 125.582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.4049
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.4049
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1348_27185"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1348_27185",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1348_27185",
    x1: 76.7857,
    y1: 115.99,
    x2: 76.7857,
    y2: 97.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9913,
    stopColor: "#BDC4D7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1348_27185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.56717,
    height: 7.56717,
    fill: "white",
    transform: "translate(32.9062 30.2687)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1348_27185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.56717,
    height: 7.56717,
    fill: "white",
    transform: "translate(32.9062 47.2948)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1348_27185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.56717,
    height: 7.56717,
    fill: "white",
    transform: "translate(32.9062 62.4292)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockIcon);
export default __webpack_public_path__ + "static/media/padlockIcon.38f076319678ec251d26cb9612af37e1.svg";
export { ForwardRef as ReactComponent };